import { defineAsyncComponent } from 'vue'

// Shared blocks (bridge between archive page (legacy) and new site / pages
export const sharedBlockDefinitions = [
  {
    keys: ['embed_block', 'content_embed'],
    component: defineAsyncComponent(() =>
      import('~/components/blocks-shared/SocialBlock.vue')
    ),
    fields: ['*']
  },
  {
    keys: ['quote_block', 'content_quote'],
    component: defineAsyncComponent(() =>
      import('~/components/blocks-shared/QuoteBlock.vue')
    ),
    fields: ['*']
  },
  {
    keys: ['rich_text_block', 'content_text'],
    component: defineAsyncComponent(() =>
      import('~/components/blocks-shared/RichTextBlock.vue')
    ),
    fields: ['*']
  },
  {
    keys: ['content_media', 'video_block'],
    component: defineAsyncComponent(() =>
      import('~/components/blocks-shared/VideoBlock.vue')
    ),
    fields: ['*']
  },
  {
    keys: ['content_info_block', 'update_block'],
    component: defineAsyncComponent(() =>
      import('~/components/blocks-shared/UpdateBlock.vue')
    ),
    fields: ['*']
  }
]
